import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import CreateIcon from "@material-ui/icons/Create";
import ListAltIcon from "@material-ui/icons/ListAlt";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import HelpIcon from "@material-ui/icons/Help";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import PostAddIcon from "@material-ui/icons/PostAdd";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import ContactSupportOutlinedIcon from "@material-ui/icons/ContactSupportOutlined";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import LocalLibraryOutlinedIcon from "@material-ui/icons/LocalLibraryOutlined";
import BookmarkBorderOutlinedIcon from "@material-ui/icons/BookmarkBorderOutlined";

// Keep these stored values compatible with existing forms and report cards.
const formIconOptions = [
  { value: "first", Icon: AccountBalanceIcon },
  { value: "second", Icon: CreateIcon },
  { value: "third", Icon: ListAltIcon },
  { value: "forth", Icon: HelpOutlineIcon },
  { value: "fifth", Icon: HelpIcon },
  { value: "sixth", Icon: ImportContactsIcon },
  { value: "seventh", Icon: MenuBookIcon },
  { value: "eighth", Icon: CreditCardIcon },
  { value: "ninth", Icon: PermIdentityIcon },
  { value: "thenth", Icon: PostAddIcon },
  { value: "twelveth", Icon: CreateOutlinedIcon },
  { value: "thirteenth", Icon: KeyboardArrowDownIcon },
  { value: "forteenth", Icon: ContactPhoneOutlinedIcon },
  { value: "fifteenth", Icon: ContactSupportOutlinedIcon },
  { value: "sixteenth", Icon: PermIdentityOutlinedIcon },
  { value: "seventeenth", Icon: LocalLibraryOutlinedIcon },
  { value: "eigtheen", Icon: BookmarkBorderOutlinedIcon }
];

export default formIconOptions;
